const listeners = new Map<string, Set<() => void>>();
const completed = new Set<string>();

export function notifyCursorAnimationComplete(completionToken: string): void {
  completed.add(completionToken);
  while (completed.size > 128) {
    const oldest = completed.values().next().value;
    if (typeof oldest !== "string") break;
    completed.delete(oldest);
  }
  const callbacks = listeners.get(completionToken);
  if (!callbacks) return;
  completed.delete(completionToken);
  listeners.delete(completionToken);
  callbacks.forEach((callback) => callback());
}

export async function waitForCursorAnimation(
  completionToken: string,
  signal: AbortSignal,
  timeoutMs: number,
): Promise<void> {
  if (completed.delete(completionToken)) return;
  await new Promise<void>((resolve) => {
    const callbacks = listeners.get(completionToken) ?? new Set<() => void>();
    const done = () => {
      clearTimeout(timer);
      signal.removeEventListener("abort", done);
      callbacks.delete(done);
      if (callbacks.size === 0) listeners.delete(completionToken);
      resolve();
    };
    const timer = setTimeout(done, timeoutMs);
    callbacks.add(done);
    listeners.set(completionToken, callbacks);
    signal.addEventListener("abort", done, { once: true });
    if (signal.aborted) done();
  });
}
